import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { InsuranceReport } from "../InsuranceNew/InsuraceDashboardComponents/InsuranceReport";
import { InsuranceInfo } from "../InsuranceNew/InsuraceDashboardComponents/InsuranceInfo";
import { InsuranceTableV2 } from "./InsuranceTableV2";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import { MODULE_API } from "../../apis";
import FETCH from "../../utils/fetch";
import swal from "sweetalert";
import "../InsuranceNew/InsuranceDashboard.css";
export const InsuranceMainDashboard = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [insuranceData, setInsuranceData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [cachedData, setCachedData] = useState({});
  const getInsuranceList = async (page) => {
    if (cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: `?module=Insurance Products V2&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);

    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      setInsuranceData(datares.records);
    }
    if (datares && datares.pagination) {
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };
  const getInsuarnceListAfterDelete = async (page) => {
    try {
      setLoading(true);
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: `?module=Income&page=${page}&limit=10`,
        body: { },
      });
      if (datares && datares.records) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deletePost = async (id) => {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          setCachedData({});
          setInsuranceData([]);
          await getInsuarnceListAfterDelete(1);
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };
   useEffect(() => {
     getInsuranceList(currentPage);
   }, [currentPage]);

  return (
    <div className="insuranceMain">
      <div className="liabilitycreate">
        <button
          className="addbuttonLiablity"
          onClick={() => {
            history.push("/organizer/insurance/add");
          }}
        >
          {" "}
          + Add Insurance
        </button>
      </div>
      <div className="insuranceMainReport" style={{position:"relative"}}>
        <InsuranceReport />
        <NewLoader isLoading={loading} />
      </div>
      <div className="insruance-info-main" style={{position:"relative"}}>
        <InsuranceInfo />
        <NewLoader isLoading={loading} />
      </div>
      <div className="insuranceCreditMainTag" style={{position:"relative"}}>
        <InsuranceTableV2
          deletePost={deletePost}
          data={insuranceData && insuranceData}
          isLoading={loading}
          getList={getInsuranceList}
          page={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
        <NewLoader isLoading={loading} />
      </div>
      {/* <div className="liabilityTableCard">
        <LiabilityTable />
        </div>  */}
    </div>
  );
};
